import React from "react";
import styles from "./OpenCallsSection.module.scss";
import openCallImage from "../../../assets/images/open-call-image.jpg";

const OpenCallsSection = () => {
  return (
    <div className={styles.openCallsSection}>
      <div className={styles.titleContainer}>
        <div className="container">
          <h2 className={styles.title}>Open Calls</h2>
        </div>
      </div>
      <div className={styles.list}>
        {Array.from(Array(6), (_, index) => (
          <div className={styles.openCall} key={index}>
            <img src={openCallImage} alt="Open Calls for Artists 2025" />
            <div className={styles.openCallTitle}>
              Open Calls for Artists 2025
            </div>
          </div>
        ))}
      </div>
      <div className={styles.otherListContainer}>
        <div className="container">
          <div className={styles.otherList}>
            {Array.from(Array(6), (_, index) => (
              <div className={styles.openCallCard} key={index}>
                <div className={styles.openCallImage}>
                  <img src={openCallImage} alt="Open Calls for Artists 2025" />
                </div>
                <div className={styles.openCallTitle}>
                  Open Calls for Artists 2025
                </div>
                <div className={styles.openCallDesc}>
                  Contrary to popular belief, Lorem Ipsum is not simply random
                  text. It has roots in a piece of classical Latin literature
                  from 45 BC, making it over 2000 years old. Richard McClintock.
                  Contrary to popular belief, Lorem Ipsum is not simply random
                  text. It has roots in a piece of classical Latin literature
                  from ...
                </div>
                <div className={styles.readMore}>Read More</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OpenCallsSection;
